import React from 'react';
import PositionCard from '../PositionCard/PositionCard';

function PositionGrid({ positions, onPositionView }) {
  if (positions.length === 0) {
    return (
      <div className="std-loading-container">
        <div className="std-loading-spinner">
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h3 className="std-loading-text" style={{ fontSize: '1.5rem', fontWeight: 600, color: '#374151' }}>No matching positions found</h3>
        <p className="std-loading-text">
          Try adjusting your filters to find more positions that match your interests.
        </p>
      </div>
    );
  }

  return (
    <div className="std-positions-grid">
      {positions.map(position => (
        <div key={position._id} className="std-position-item">
          <PositionCard
            position={position}
            onView={() => onPositionView(position)}
          />
        </div>
      ))}
    </div>
  );
}

export default PositionGrid;